<template>
  <section class="loading">
    <i class="loader"></i>
    <span>
      {{text}}
    </span>
  </section>
</template>

<script>

export default {
  name: 'm-loading',

  props: {
    text: {
      type: String,
      default: '人家在加载呢...',
    },
  },
};

</script>

<style lang="scss" scoped>
.loading {
  text-align: center;
  margin: 2em auto;

  .loader {
    width: 1em;
    height: 1em;
    vertical-align: middle;
    display: inline-block;
    border-top: .125em solid #FF519F;
    border-right: .125em solid #FF519F;
    border-bottom: .125em solid #FF519F;
    border-left: .125em solid transparent;
    border-radius: 50%;
    transform: translateZ(0);
    animation: loading 1.1s infinite linear;
  }

  span {
    font-size: .75em;
    color: #C4C4C4;
  }
}

@keyframes loading {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

</style>



// WEBPACK FOOTER //
// index.vue?574ccc02